import { isSafari, isIOS } from 'react-device-detect';

interface NavigatorStandalone extends Navigator {
  standalone?: boolean;
}

export function isIOSSafariNotInstalled(): boolean {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const nav: NavigatorStandalone = window.navigator;
  const isIOSStandalone = nav.standalone === true;
  return isIOS && isSafari && !isStandalone && !isIOSStandalone;
}
